module.exports = __webpack_public_path__ + "a972473547551d929b1c3a150ed65092.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/turtle-shell-hat-s.png
// module id = 2950
// module chunks = 0